import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { IdSystemService } from './id-system';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { sanitizeReturnUrl } from '../router/guard-navigation.util';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatorService {
  private idSystem = inject(IdSystemService)
  private router = inject(Router)
  private authSubject = new BehaviorSubject<boolean>(this.idSystem.isAuthed)
  readonly auth$ = this.authSubject.pipe(distinctUntilChanged())

  get isAuthed() {
    return this.idSystem.isAuthed
  }

  constructor() {
    this.idSystem.events$.subscribe(event => {
      if (event.event === 'login') {
        this.authSubject.next(true)
      }
      else if (event.event === 'logout') {
        this.authSubject.next(false)
      }
      else if (event.event === 'error') {
        // 401 это нормально
        if (!(event.error instanceof HttpErrorResponse && event.error.status === 401)) {
          this.router.navigate(['/error'], { queryParams: { 'return_url': sanitizeReturnUrl(this.router.url || '/') } })
        }
      }
    })
  }

  login() {
    return this.idSystem.login({
      lang: 'ru',
      theme: 'light',
      skipLauncher: true
    })
  }

  logout() {
    return this.idSystem.logout(window.location.origin + '/')
  }
}
